import QuestionMaker from './component/front/front-helpers/QuestionMaker'
import { ConstructionModalFilter } from './component/front/front-helpers/ConstructionModalFilter'
import { MenuManager } from './component/front/front-helpers/MenuManager'

document.addEventListener('DOMContentLoaded', e => {
  ConstructionModalFilter()
  QuestionMaker()
  MenuManager()
})
